import positiveReportFormService from "./positiveReportFormService";

const positiveReportService = [
    ...positiveReportFormService
];

export { positiveReportService as default, positiveReportFormService }